import { MessageSellerWrapper } from './components/MessageSellerWrapper';
import { MessageBuyerWrapper } from './components/MessageBuyerWrapper';
import { MessageGlobalWrapper } from './components/MessageGlobalWrapper';
import routes from './routes';

export { routes as messagingRoutes, MessageSellerWrapper, MessageBuyerWrapper };

export default MessageGlobalWrapper;
